<template src="./offerte.html"></template>

<script>
import { get_offerte } from "@/api/api.offerte.js";

import carousel from "@/components/dialog/OfferteCarousel.vue";

export default {
  components: {
    carousel,
  },

  data: () => ({
    dati: [],

    dialogCarousel: false,
  }),

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];

      try {
        let res = await get_offerte();

        this.dati = res.data;
      } catch (error) {
        console.log("offerte.vue " + error);
      }
    },

    getImg() {
      return this.$load.getUrlImg() + "/offerte/sfondo.png";
    },

    onClickImg(file) {
      if (file.Descrizione == "colori") this.dialogCarousel = true;
    },

    chiudiCarousel() {
      this.dialogCarousel = false;
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);
    this.caricaDati();
  },
};
</script>